import React, { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';

export default function TransitionAlerts({ ...other }) {

  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    setOpen(other.open)
  }, [other.open])


  return (
    <Box sx={{ width: '100%' }}>
      <Collapse in={open}>
        <Alert
          severity={other.severity}
          // action={
          //   <IconButton
          //     aria-label="close"
          //     color="inherit"
          //     size="small"
          //     onClick={() => {
          //       setOpen(false);
          //     }}
          //   >
          //     <CloseIcon fontSize="inherit" />
          //   </IconButton>
          // }
          sx={{ mb: 2 }}
        >
          {other.messenger}
        </Alert>
      </Collapse>
    </Box>
  );
}
